import { action, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import Select from '../forms/select';

import { DataLoadStatus, SelfEvaluationEditorProps, SelfEvaluation } from '../../types';
import SelfEvaluationEditorStore from '../../stores/SelfEvaluationEditorStore';

@inject('selfEvaluationEditorStore')
@observer
class MentorProgramEditor extends React.Component<SelfEvaluationEditorProps> {
  private store: SelfEvaluationEditorStore;

  public constructor(props: SelfEvaluationEditorProps) {
    super(props);
    this.store = props.selfEvaluationEditorStore!;
  }

  public async componentDidMount() {
    if (this.store.loadStatus === DataLoadStatus.NOT_STARTED) {
      await this.store.loadProgramTopics();
      const scores: SelfEvaluation[] = this.store.programTopics.map(programTopic => ({
        id: -1,
        programId: programTopic.id,
        programName: programTopic.name,
        score: 1
      }));
      
      runInAction(() => this.store.selfEvaluations = scores);
    }
  }

  public render() {
    return (
      <>
        <h3 className="subtitle">Please rate yourself for the following programs</h3>

        {/* render the blocks first */}
        <div className="columns is-multiline edittable-card-container">
          {this.renderPrograms()}
        </div>
      </>
    );
  }

  private renderPrograms = () => {
    const blocks = this.store.selfEvaluations.map((selfEvaluationScore, index) => {
      const scoreString = !selfEvaluationScore.score ?  '' : `${selfEvaluationScore.score}`;
      return (
        <div className="column is-12" key={`program-${index}-${selfEvaluationScore.programName}`} >
          <div className="card edittable-card">
            <div className="card-content" >
              <p className="title is-size-6">{selfEvaluationScore.programName}</p>
              <Select
                  helpMessage="1 = beginner, 10 = expert"
                  label="How would you rate yourself on this topic?"
                  layoutClassName={`column is-12 block-${index}`}
                  onChange={this.handleSelfEvaluationChange}
                  options={[ '1', '2', '3', '4', '5', '6', '7', '8', '9', '10' ]}
                  selectClassName={`block-${index}`}
                  value={scoreString}
              />
            </div>
          </div>
        </div>
      );
    });

    return blocks;
  }

  @action
  private handleSelfEvaluationChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const score = +event.currentTarget.value;
    const blockId = +event.currentTarget.classList.toString().match(/block-(\d+)/)![1];
    const existingScores = this.store.selfEvaluations;
    const oldScore = existingScores[blockId];
    const newScore = { ...oldScore, score };
    existingScores[blockId] = newScore;
  }
}

export default MentorProgramEditor;



// WEBPACK FOOTER //
// ./src/common/widgets/MentorSelfEvaluationEditor.tsx